
import { Component, Vue, Watch } from "vue-property-decorator";

import dayjs from "dayjs";
import {
  getHistoryNum,
  getPrintGetHistoryDetail,
  getPackageList,
  getPrintNo,
  queryMessageRemind, updateMessageRemind,
} from "@/api/print";
import { getOrgCodeListByPage } from "@/api/service";
import { DestinationOrgcodename, ProgressBar } from "@/views/components";
import PrintConfirm from "./PrintConfirm.vue";
import YtoTable from "@/views/components/YtoTable/TtoTable.vue";
import config from "./config";
import Form2 from "./Form2.vue";
import TableHeader from "./TableHeader.vue";
import { date_day_add, parseTime } from "@/utils";
import Enumerable from "linq";
import { ErrorEnum } from "@/common/ErrorEnum";
import {PaperSizeEnum, PaperSizeOptions} from "@/common/enum/paper-size";
import { PrintUtils } from "@/common/print-utils";
import {Template} from "webpack";
import { LogHelper } from '@/common/LogHelper';
import MessageDialog from "./MessageDialog.vue";
import { SystemConfigModule } from "@/store/modules/store_systemconfig";
// import { logFunc } from '@/utils/prototype'
// import {
//   beforeMethod,
//   afterMethod,
//   onException,
//   Metadata,
//   MethodSignature
// } from "kaop-ts";
// import {LogUtils} from "@/common/LogUtils";

@Component({
  name: "PackagePrint",
  computed: {
    PaperSizeOptions() {
      return PaperSizeOptions
    }
  },
  components: {
    MessageDialog,
    DestinationOrgcodename,
    YtoTable,
    Form2,
    TableHeader,
    ProgressBar,
    PrintConfirm,
  },
})
export default class extends Vue {
  @Watch("UnpackOrgName", { deep: false })
  oncurrentRowChanged(val: string) {
    if (val.length === 0) {
      this.inputModel.input_UnpackOrgName = "";
    }
  }

  @Watch("printCount", { deep: false, immediate: true })
  onPrintCountChanged() {
    this.printCountValue = this.printCount;
  }

  onPackageTypeChanged() {
    if (this.isHKPackageType) {
      this.inputModel.input_ProductType = "普通";
    }
    this.SearchPrintDataFunc();
  }

  private PrintConfirmFunc(printConfirmFlag) {
    debugger;
    this.printConfirmdialogshow = false;
    if (printConfirmFlag) {
      this.submitPrintOnce();
      this.$nextTick(() => {
        this.SavePrintNumber(this.multipleSelection);
      });
    }
  }
  private SavePrintNumber(multipleSelection) {
    let _json = [];
    _json = multipleSelection;
    if (typeof obj_LocalData_Core != "undefined") {
      var _sourceArray = _json.map(function (item) {
        return {
          UnbagOrgName: item.UnpackOrgName,
          UnbagOrgCode: item.UnpackOrgCode,
          PackageName: item.Name,
          PackageType: item.PackageType,
          ProductType: item.ProductType,
          KeyData: item.ID,
          FirstCode: item.FirstCode,
          PrintNum: Number.parseInt(item.countNum),
          EXTEND1: "",
          EXTEND2: "",
          EXTEND3: "",
          EXTEND4: "",
          EXTEND5: "",
        };
      });
      obj_LocalData_Core.saveBagPrintNumberRecord(_sourceArray);
    }
  }
  private rowEdit(row, idx) {
    row.edit = true;
    this.$nextTick(() => {
      var input: any = this.$refs["mark" + idx];
      if (input) {
        input.focus();
      }
    });

    this.$forceUpdate();
  }

  public form2Key = "";
  private printConfirmTableData = [];
  private printConfirmdialogshow = false;
  public loginData: LoginData; //系统登陆数据
  //打印进度条
  private progressBarDialogTitle = "";
  private proressBarDialogShow = false;
  private printCountValue = 0;
  private printCount = 0;
  private totalCount = 0;
  //-----
  private tabSelectIndex = "0";

  //查询打印数量
  private printCountDialogFormVisible = false;
  //-----
  //查询打印明细
  private printDetailDialogFormVisible = false;
  //-----
  private form = {};

  private globalConfig: any = {};

  private inputModel: inputDataModel_PackagePrint = {
    input_PackageName: "",
    input_UnpackOrgName: "",
    input_PrinterName: "",
    input_PackageType: "",
    input_ProductType: "",
    input_LatticeNo: "",
    input_PaperSize: "",
  };
  public loading = false;
  public unpackageNameOptions = [];
  public input_DateRange = [];
  public timeOptionRange: String = "";
  public pickerOptions = {
    onPick: (time) => {
      if (time.minDate && !time.maxDate) {
        this.timeOptionRange = time.minDate;
      }
      if (time.maxDate) {
        this.timeOptionRange = null;
      }
    },
    disabledDate: (time) => {
      let timeOptionRange: any = this.timeOptionRange;
      let secondNum = 6 * 60 * 60 * 24 * 1000;
      if (timeOptionRange) {
        return (
          time.getTime() > timeOptionRange.getTime() + secondNum ||
          time.getTime() < timeOptionRange.getTime() - secondNum
        );
      }
    },
  };

  public pickerOptions2 = {
    onPick: (time) => {
      if (time.minDate && !time.maxDate) {
        this.timeOptionRange = time.minDate;
      }
      if (time.maxDate) {
        this.timeOptionRange = null;
      }
    },
  };
  public printCountForm = {
    dateRange: [],
  };
  public printDetailForm = {
    packageName: "",
    dateRange: [],
  };
  public table1Loading = false;

  public hasPaperSizeOption: boolean = false;

  public isShowMessageDialog: boolean = false;
  public messages: Array<{ messageTitle: string, messageContent: string, readFlag: number }> = [];
  private pullTimerId: any = null;

  get submitPrintDisable() {
    var c = Enumerable.from(this.printedResultShowList);
    var b = !c.any((f) => f.ID && parseInt(f.countNum) > 0);
    console.log(`submitPrintDisable:${this.printedResultShowList.length}-${b}`);
    return b;
  }

  get isHKPackageType() {
    return this.inputModel.input_PackageType === "HK";
  }

  get hasMessage() {
    return  this.messages.length > 0;
  }

  get unReadMessageCount() {
    return this.messages.filter((item) => !item.readFlag).length;
  }

  public remoteMethod(query) {
    if (query !== "") {
      this.loading = true;
      setTimeout(() => {
        this.loading = false;
        var body = {
          queryValue: query, //过滤字符串
          queryType: "19",
          viewType: "1",
          extend1: 1, //当前页
          extend2: 10, //页大小
          extend3: "", //过滤字段
        };
        var job = {
          devMac: "00-00-00-00-00-00",
          devType: "0",
          body: body,
        };
        var requestJson = JSON.stringify(job);
        var orgs = getOrgCodeListByPage(requestJson);
        var orgsJson = JSON.parse(orgs);
        if (orgsJson.respcode === "000") {
          this.unpackageNameOptions = orgsJson.data.busiData.records.map(
            (element) => {
              return { value: element.code, label: element.name };
            }
          );
        } else {
          this.unpackageNameOptions = [];
        }
      }, 500);
    } else {
      this.unpackageNameOptions = [];
    }
  }

  mounted() {
    this.inputModel.input_PackageType = "QY";
    this.inputModel.input_ProductType = "普通";
    this.hasPaperSizeOption = PrintUtils.hasPaperSizeOption();
    this.inputModel.input_PaperSize = this.hasPaperSizeOption ? PrintUtils.getDefaultPaperSize() : "";
    // try {
    //注册查询打印数据回传
    //   obj_PackagePrint.regist_SearchPrintDataCallback(
    //     this.SearchPrintDataCallback
    //   );
    //注册回传打印数量
    //   obj_PackagePrint.regist_PrintedCountCallback(this.PrintedCountCallback);
    // } catch (error) {
    // }
    var loginDataStr = obj_GlobalData_Core.getLoginData();
    this.loginData = JSON.parse(loginDataStr);
    this.globalConfig = SystemConfigModule.globalData;
    this.GetAllPrinters(); //获取所有打印机
    //给两个查询框赋值
    var d1 = date_day_add(new Date(), -6);
    this.printDetailForm.dateRange[0] = d1 + " 00:00:00";
    this.printDetailForm.dateRange[1] = parseTime(
      new Date(),
      "{y}-{m}-{d} 00:00:00"
    );
    this.printCountForm.dateRange[0] = d1 + " 00:00:00";
    this.printCountForm.dateRange[1] = parseTime(
      new Date(),
      "{y}-{m}-{d} 00:00:00"
    );
    //-----
    setTimeout(() => {
      this.SearchPrintDataFunc();
    }, 100);
    this.startPullMessageTimer();
  }

  beforeDestroy() {
    this.stopPullMessageTimer();
  }

  //打印完成后去除选中和后面的数字
  private ResetAfterPrinted() {
    (
      this.$refs.multipleTable as Vue & {
        clearSelection: Function;
      }
    ).clearSelection();
    var newArray = this.printedResultShowList.map(function (item) {
      return {
        countNum: "",
        ID: item.ID,
        Name: item.Name,
        Type: item.Type,
        UnpackOrgName: item.UnpackOrgName,
        UnpackOrgCode: item.UnpackOrgCode,
        ProductType: item.ProductType,
        Count: item.Count,
        edit: false,
        FirstCode: item.FirstCode,
      };
    });
    this.printedResultShowList = newArray;
  }

  //获取所有打印机
  // @logFunc('log装饰器')
  // @beforeMethod(inlog)
  // @afterMethod(outlog)
  private GetAllPrinters() {
    var printersStr = obj_Printer_Core.getAllPrinters();
    if (printersStr == null || printersStr.length == 0) {
      return;
    }
    var printers = JSON.parse(printersStr);

    this.options = [];
    printers.forEach((element) => {
      let printName = element.printName;
      let defultPrinter = false;
      // let workOffline = false;
      element.propertyDatas.forEach((_element) => {
        if (_element.Name === "Default" && _element.Value === true) {
          defultPrinter = true;
          printName += "|(默认打印机)";
        } else if (_element.Name === "WorkOffline" && _element.Value === true) {
          // workOffline = true;
          printName += "|(脱机)";
        }
      });

      if (defultPrinter) {
        this.options.unshift({
          value: `${element.printName}`,
          label: `${printName}`,
        });
      } else {
        this.options.push({
          value: `${element.printName}`,
          label: `${printName}`,
        });
      }
    });

    // this.options = printers.map((item) => {
    //   return { value: `${item}`, label: `${item}` };
    // });
    if (this.options.length > 0) {
      this.inputModel.input_PrinterName = this.options[0].value;
    }
  }
  //enter换行的功能
  private validateCounts(row, index, e) {
    var keyCode = e.keyCode || e.which || e.charCode;
    if (keyCode === 13) {
      var el = document.getElementById("editinput" + (index + 1).toString());
      this.selectElementContents(el);
    }
  }
  private isPrintIngFlag = false; //是否正在打印
  //提交打印，判断是否正在打印
  private SubmitPrintFunc() {
    let totalnum = 0;
    let singleCount = 0;
    if (this.multipleSelection.length == 0) {
      this.$message.error("请先勾选要打印的条目");
      return;
    }
    try {
      debugger;
      this.multipleSelection.forEach((element) => {
        if (element.countNum == "0" || element.countNum == "") {
          this.$message.error("打印数量不能为0");
          throw new Error("EndIterative");
        }
        singleCount = Number.parseInt(element.countNum.toString());
        if (singleCount > 500) {
          this.$message.error("单项的打印数量超过500张,请重新输入数量");
          throw new Error("EndIterative");
        }
        totalnum = totalnum + singleCount;
      });
    } catch (error) {
      if (error.message == "EndIterative") {
        return;
      }
    }
    if (totalnum > 10000) {
      this.$message.warning(
        "打印的数量为" +
          totalnum +
          "张，总数超过10000张，请重新选择需要打印的数量"
      );
      return;
    }
    if (!this.isPrintIngFlag) {
      try {
        this.printConfirmTableData = this.multipleSelection;
        this.printConfirmdialogshow = true;
      } catch (error) {
        console.log("打印出错:" + error);
      }
    } else {
      this.$message.warning("有打印任务正在执行,请稍后");
    }
  }

  //构造打印数据
  public submitPrint() {
    try {
      this.isPrintIngFlag = true;
      var _requestModel = this.multipleSelection.map((item) => {
        let type = "";
        if (item.Type === "汽运") {
          type = "QY";
        } else if (item.Type === "航空") {
          type = "HK";
        } else {
          type = item.Type;
        }
        return {
          packageName: item.Name,
          unBagOrgCode: item.UnpackOrgCode,
          unBagOrgName: item.UnpackOrgName,
          packageType: type,
          productType: this.inputModel.input_ProductType,
          key: item.ID,
          num: parseInt(item.countNum),
          printPersonCode: this.loginData.userCode,
          printPersonName: this.loginData.userName,
          // printNum:1,//新增
          // createOrgCode:"",//新增
          // createOrgName:"",//新增
          // takeApartOrgCode:"",//新增
          // opOrgType:"",//新增
          // createTime:"",//新增
          firstCode: item.FirstCode,
        };
      });
      var responseData = getPrintNo(JSON.stringify(_requestModel));
      var responseDataJson = JSON.parse(responseData);
      if (responseDataJson.respcode === "000") {
        if (
          responseDataJson.data.listNos !== null &&
          responseDataJson.data.listNos.length > 0
        ) {
          this.proressBarDialogShow = true;
          this.printCount = 0;
          this.progressBarDialogTitle = "打印中";
          var totalCount = responseDataJson.data.listNos.length;
          this.totalCount = totalCount;
          setTimeout(() => {
            this.printStart(responseDataJson.data.listNos);
          }, 500);
        } else {
          this.$message.error(ErrorEnum.BD002);
        }
      } else {
        this.$message.error(responseDataJson.respMessage);
      }
    } catch (error) {
      console.log("打印出错:" + error);
    } finally {
      this.isPrintIngFlag = false;
    }
  }
  public waitPrintList=[];
  //构造打印数据
  public submitPrintOnce() {
    if (this.isPrintIngFlag) {
      LogHelper.Print("重复点击问题");
      return;
    }
    let needRequestList = [];
    this.waitPrintList = [];
    try {
      this.isPrintIngFlag = true;
      needRequestList = this.multipleSelection;

      let typeProduct = ""


      for (let index = 0; index < needRequestList.length; index++) {
        let element = needRequestList[index];
        let type = "";
        if (element.Type === "汽运") {
          type = "QY";
        } else if (element.Type === "航空") {
          type = "HK";
        } else {
          type = element.Type;
        }


        if ( element.ProductType == "异形"){
          typeProduct = "YX";
        } else if ( element.ProductType == "国际") {
          typeProduct = "GJ";
        }else if ( element.ProductType == "文件"){
          typeProduct = "WJ";
        } else if ( element.ProductType == "业务废品") {
          typeProduct = "WZ";
        }
        else{
          typeProduct = element.ProductType;
        }


        let singleRequest =  {
          packageName: element.Name,
          unBagOrgCode: element.UnpackOrgCode,
          unBagOrgName: element.UnpackOrgName,
          packageType: type,
          productType: typeProduct,
          key: element.ID,
          num: parseInt(element.countNum),
          printPersonCode: this.loginData.userCode,
          printPersonName: this.loginData.userName,
          firstCode: element.FirstCode,
        };
        let _requestModel = [];
        _requestModel.push(singleRequest);

        var responseData = getPrintNo(JSON.stringify(_requestModel));
        var responseDataJson = JSON.parse(responseData);
        if (responseDataJson.respcode === "000") {
          if (
            responseDataJson.data.listNos !== null &&
            responseDataJson.data.listNos.length > 0
          ) {
            this.waitPrintList = this.waitPrintList.concat(responseDataJson.data.listNos);
          } else {
            this.$message.error(ErrorEnum.BD002);
            break;
          }
        } else {
          this.$message.error(responseDataJson.respMessage);
        }
      }

      if (this.waitPrintList.length>0) {
        this.proressBarDialogShow = true;
        this.printCount = 0;
        this.progressBarDialogTitle = "打印中";
        this.totalCount = this.waitPrintList.length;
        setTimeout(() => {
          this.printStart(this.waitPrintList);
        }, 300);
        PrintUtils.savePaperSize(this.inputModel.input_PaperSize);
      } else {
        console.log("打印列表为空");
        this.isPrintIngFlag = false;
      }
    } catch (error) {
      this.isPrintIngFlag = false;
      console.log("打印出错:" + error);
    }
  }

  //开始打印
  private async printStart(list) {
    for (let index = 0; index < list.length; index++) {
      await this.ShowAsync(index);
      this.printOne(list[index]);
    }
    this.ResetAfterPrinted();

    this.form2Key = new Date().getTime().toString();
    this.progressBarDialogTitle = "打印结束";
    this.proressBarDialogShow = false;
    this.isPrintIngFlag = false;
  }

  //展示打印进度
  public async ShowAsync(index) {
    return new Promise((resolve) => {
      setTimeout(() => {
        this.printCount = index + 1;
        resolve("success");
      }, 300);
    });
  }

  //获取打印的模板名称
  private getTemplateName() {
    debugger;
    var templateName = "";
    let currentType = this.printedResultShowList[0].ProductType;
    if (this.inputModel.input_PackageType === "QY") {
      switch (currentType) {
        case "普通":
          templateName = "普通";
          break;
        case "圆准达":
          templateName = "圆准达";
          break;
        case "VIP":
          templateName = "VIP";
          break;
        case "异形":
          templateName = "YX";
          break;
        case "国际":
          templateName = "GJ";
          break;
        case "文件":
          templateName = "WJ";
          break;
        case "业务废品":
          templateName = "WZ";
          break;
        default:
          break;
      }
    } else {
      switch (currentType) {
        case "普通":
          templateName = "航空件";
          break;
        default:
          break;
      }
    }

    templateName = PrintUtils.buildTemplateNameByPaperSize(templateName, this.inputModel.input_PaperSize);

    return templateName;
  }

  //打印
  private printOne(data) {
    var templateName = this.getTemplateName();
    var templatePath = "\\PrintTemplate\\" + templateName + ".frx";
    var endDate = "";
    if (dayjs(data.expireDateTime).isValid()) {
      var date = dayjs(data.expireDateTime);
      endDate = date.format("YYYY-MM-DD");
    } else {
      endDate = dayjs().format("YYYY-MM-DD");
    }

    var strs = data.packageName.split("-");
    let packagename = "";
    if (data.packageName.indexOf("-") == -1) {
      packagename = data.packageName;
    } else {
      packagename = strs[0];
    }

    let firstcode = "";
    if (data.firstCode == undefined || data.firstCode == "") {
      firstcode = strs.length > 1 ? strs[1].trim() : "";
    } else {
      firstcode = data.firstCode;
    }

    const hasNewCreatePackageRule = obj_Printer_Core.hasNewCreatePackageRule && obj_Printer_Core.hasNewCreatePackageRule();
    var _data = {
      WayBillNo: data.waybillNo,
      PrintDate: dayjs().format("YYYY-MM-DD HH:MM"),
      PrintTime: dayjs().format(hasNewCreatePackageRule ? "HH:mm" : "HH:mm:ss"),
      UnpackOrgCode: data.unBagOrgCode,
      UnpackOrgName: data.unBagOrgName,
      SrcOrgCode: this.loginData.orgCode,
      // PackageName: strs.length > 0 ? strs[0] : null,
      // Datoubi: strs.length > 1 ? strs[1] : null,
      PackageName: packagename,
      Datoubi: firstcode,
      /* EndDate = result.ExpireDateTime*/
      EndDate: endDate,
      Info: "",
    };
    var _info = {
      mn: _data.WayBillNo,
      dtb: _data.Datoubi,
      dest: _data.UnpackOrgCode,
      src: _data.SrcOrgCode,
    };
    _data.Info = JSON.stringify(_info);
    var array = [];
    array.push(_data);
    var result = obj_Printer_Core.print(
      JSON.stringify(array),
      templatePath,
      this.inputModel.input_PrinterName
    );
    if (result) {
      this.$notify.error(result);
    }
  }

  private progressBarFormCloseFunc() {
  }

  public options = [
    {
      value: "",
      label: "",
    },
  ];
  public tableHeight = null;

  private SearchPrintDataCallback(printDatas) {
    setTimeout(() => {
      debugger;
      this.printedResultShowList = [];
      this.multipleSelection.forEach((element) => {
        if (element.ID) {
          this.printedResultShowList.push({
            ID: element.ID,
            Name: element.Name,
            Type: element.Type,
            UnpackOrgName: element.UnpackOrgName,
            UnpackOrgCode: element.UnpackOrgCode,
            Count: element.Count,
            FirstCode: element.FirstCode,
            PackageType: element.PackageType,
            ProductType: element.ProductType,
            edit: false,
          });
        }
      });
      //获取之前选中的部分
      var _printedResultShowList = this.printedResultShowList;
      _printedResultShowList.forEach((row) => {
        this.$nextTick(() => {
          (
            this.$refs.multipleTable as Vue & {
              toggleRowSelection: Function;
            }
          ).toggleRowSelection(row, true);
        });
      });

      for (let index = 0; index < printDatas.length; index++) {
        const element = printDatas[index];
        var result = this.FindIsExist(element);
        if (!result) {
          this.printedResultShowList.push({
            ID: element.ID,
            Name: element.Name,
            Type: element.Type,
            UnpackOrgName: element.UnpackOrgName,
            UnpackOrgCode: element.UnpackOrgCode,
            countNum: "",
            FirstCode: element.FirstCode,
            PackageType: element.PackageType,
            ProductType: element.ProductType,

            edit: false,
          });
        }
      }
      //获取之前存储的预打印数量
      if (typeof obj_LocalData_Core != "undefined") {
        let _array = this.printedResultShowList.map(function (item) {
          return {
            UnbagOrgName: item.UnpackOrgName,
            UnbagOrgCode: item.UnpackOrgCode,
            PackageName: item.Name,
            PackageType: item.PackageType,
            ProductType: item.ProductType,
            KeyData: item.ID,
            FirstCode: item.FirstCode,
            PrintNum: 0,
            EXTEND1: "",
            EXTEND2: "",
            EXTEND3: "",
            EXTEND4: "",
            EXTEND5: "",
          };
        });
        let _resultSearchBagPrintNumberRecord = JSON.parse(
          obj_LocalData_Core.findBagPrintNumberRecord(_array)
        );

        _resultSearchBagPrintNumberRecord.forEach((element) => {
          if (
            this.printedResultShowList.some(
              // (_item) => _item.ID == element.KeyData
              (_item) => _item.UnpackOrgCode == element.UnbagOrgCode
            )
          ) {
            let _num =
              element.PrintNum == 0 || element.PrintNum == "0"
                ? ""
                : element.PrintNum;
            this.printedResultShowList.filter(
              // (_item) => _item.ID == element.KeyData
              (_item) => _item.UnpackOrgCode == element.UnbagOrgCode
            )[0].countNum = _num;
          }
        });
      }

      this.table1Loading = false;
    }, 500);
  }

  private FindIsExist(element) {
    for (let index = 0; index < this.multipleSelection.length; index++) {
      const _element = this.multipleSelection[index];
      // if (_element.ID == element.ID) {
      if (_element.UnpackOrgCode == element.UnpackOrgCode) {
        return true;
      }
    }
    return false;
  }

  private handelSelectPrintRow(selection, row) {
    this.multipleSelection = selection;
    // row.edit = !row.edit;
    this.$nextTick(() => {
      var el = document.getElementById("editinput" + row.row_index);
      this.selectElementContents(el);
    });
  }

  private loseFcous(row) {
    row.edit = false;
  }

  private cellClick(row) {
    row.seen = true;
  }

  private printedResultShowList = [
    // {
    //   ID: "",
    //   Name: "嘉峪关中转包-934",
    //   UnpackOrgName: "甘肃嘉峪关接驳点",
    //   Type: "汽运",
    //   edit: false,
    //   Count: "",
    //   UnpackOrgCode: ""
    // }
  ];
  public multipleSelection = [];

  public handleSelectionChange(val) {
    this.multipleSelection = val;
    // val.length == this.printedResultShowList.length ||
    if (val.length == 0) {
      for (let index = 0; index < this.printedResultShowList.length; index++) {
        this.printedResultShowList[index].edit = false;
      }
    }
  }

  private searchResultShowList = [];

  private getFormValue(element) {
    this.inputModel = element;
  }

  //获得焦点，选中文本
  private getInputFocus(event): void {
    event.currentTarget.select();
  }

  private config = config;

  public selectElementContents(el) {
    try {
      el.blur();
      el.focus();
      el.select();
    } catch (error) {}
  }
  //查询按钮
  public SearchPrintDataFunc() {
    if (this.inputModel.input_PackageType === "HK" && !obj_Printer_Core.hasHKPackageRule) {
      this.$message.warning("使用航空类型建包需要升级客户端！");
      return;
    }

    this.countNumReadonly = false;
    this.table1Loading = true;
    setTimeout(() => {
      this.GetPackageListAsync();
    }, 500);
  }
  //查询方法的实现
  public GetPackageListAsync() {
    return new Promise((resolve, reject) => {
      try {
        resolve("success"); // 成功
        //收集包签号
        let input_PackageNameValue = this.inputModel.input_PackageName;
        let packageName = "";
        if (input_PackageNameValue.includes("\n")) {
          let valueArray = input_PackageNameValue.split("\n");
          valueArray.forEach((element) => {
            element = element.trim();
            if (element.length > 0) {
              packageName += element + ",";
            }
          });
          //去除末尾的,
          if (packageName.length > 0) {
            packageName = packageName.substr(0, packageName.length - 1);
          }
        } else {
          packageName = input_PackageNameValue;
        }
        //收集格口号
        let input_LatticeNoValue = this.inputModel.input_LatticeNo;
        let latticeNo = "";
        if (input_LatticeNoValue.includes("\n")) {
          let valueArray = input_LatticeNoValue.split("\n");
          valueArray.forEach((element) => {
            // element = element.replace(/\b(0+)/gi,"");//去除前面的0
            element = this.CheckFirstCode(element);
            //补齐三位数字
            while (element.length < 3 && element.length > 0) {
              element = "0" + element;
            }
            if (element.length > 0) {
              latticeNo += element + ",";
            }
          });
          //去除末尾的,
          if (latticeNo.length > 0) {
            latticeNo = latticeNo.substr(0, latticeNo.length - 1);
          }
        } else {
          latticeNo = input_LatticeNoValue;
        }

        var loginDataStr = obj_System_Core.getLoginData();
        this.loginData = JSON.parse(loginDataStr);
        let _productType = "普通";
        if (this.inputModel.input_ProductType == "WJ") {
          _productType = "WJ";
        }
        else if (this.inputModel.input_ProductType == "WZ")
        {
          _productType = "WZ";
        }
        var _request: GetNewPrintListRequest = {
          orgCode: this.loginData.orgCode,
          pageOrgCode: this.inputModel.input_UnpackOrgName,
          packageName: packageName,
          //由于目前没有航空的包签规则，现在默认通过汽运类型查询，但是操作依旧使用对应的逻辑
          packageType: this.inputModel.input_PackageType,
          //由于目前没有圆准达和vip的包签规则，现在默认通过普通包签类型查询，但是操作依旧使用对应的逻辑
          // productType: this.inputModel.input_ProductType,
          productType: _productType,
          page: "",
          rows: "",
          latticeNo: latticeNo,
          firstCode: "",
        };
        var _result = getPackageList(JSON.stringify(_request));
        var _jsonOrgin = JSON.parse(_result);
        if (_jsonOrgin.respcode !== "000")
        {
          this.$message.error(_jsonOrgin.respMessage);
         // return;
        }
        // 排序:按照用户输入的顺序进行排序
        let _json = this.SortArray(_jsonOrgin);
debugger
        if (_json !== null) {
          let typeProduct = ""
          if (this.inputModel.input_ProductType == "YX"){
            typeProduct = "异形";
          } else if (this.inputModel.input_ProductType == "GJ") {
            typeProduct = "国际";
          }else if (this.inputModel.input_ProductType == "WJ"){
            typeProduct = "文件";
          } else if (this.inputModel.input_ProductType == "WZ") {
            typeProduct = "业务废品";
          }
          else{
            typeProduct = this.inputModel.input_ProductType;
          }

            var newArray = _json.map(function (item) {
            let type = "";
            if (item.packageType === "QY") {
              type = "汽运";
            } else if (item.packageType === "HK") {
              type = "航空";
            } else {
              type = item.packageType;
            }


            return {
              ID: item.key,
              Name: item.packageName,
              Type: type,
              UnpackOrgName: item.unBagOrgName,
              UnpackOrgCode: item.unBagOrgCode,
              FirstCode: item.firstCode == undefined ? "" : item.firstCode,
              PackageType: item.packageType,
              ProductType: typeProduct,
            };
          });

          this.SearchPrintDataCallback(newArray);
        } else {
          this.printedResultShowList = [];
          this.table1Loading = false;
        }
      } catch (error) {
        console.log(error);
        reject("fail"); // 失败
      }
    });
  }
  private CheckFirstCode(data) {
    try {
      let _data = data.trim();
      var n = Number(_data);
      if (!isNaN(n)) {
        // 数字
        return _data;
      } // 字符
      else {
        return "";
      }
    } catch (error) {
      return "";
    }
  }
  private SortArray(arr) {
    let sourceArray = [];
    if (arr != null && arr.data != null) {
      sourceArray = arr.data;
    }

    var input_PackageNameValue = this.inputModel.input_PackageName;
    var PackageName = "";
    if (input_PackageNameValue.includes("\n")) {
      var valueArray = input_PackageNameValue.split("\n");

      for (let index = 0; index < valueArray.length; index++) {
        const element = valueArray[index];
        if (element.trim().length > 0) {
          sourceArray.map((item, _index) => {
            if (item.packageName.indexOf(element) != -1) {
              sourceArray.unshift(sourceArray.splice(_index, 1)[0]);
            }
          });
        }
      }
      sourceArray.reverse();
      return sourceArray;
    } else {
      PackageName = input_PackageNameValue;
      if (arr != null && arr.data != null) {
        return arr.data;
      } else {
        return [];
      }
    }
  }

  public UnpackOrgName = "";

  private ResetFunc() {
    this.inputModel.input_PackageName = "";
    this.inputModel.input_UnpackOrgName = "";
    this.inputModel.input_PackageType = "QY";
    this.inputModel.input_ProductType = "普通";
    this.inputModel.input_LatticeNo = "";
    if (this.options.length > 0) {
      this.inputModel.input_PrinterName = this.options[0].value;
    }
  }

  private printGetHistoryDetailRequest: PrintGetHistoryDetailRequest = {
    downloadTime: "",
    expireTime: "",
    extend1: "",
    extend2: "",
    extend3: "",
    matOrgCode: "",
    packageName: "",
    packageType: "",
    printSequence: "",
    productType: "",
    takeApartOrgCode: "",
    takeApartOrgName: "",
    waybillNo: "",
  };

  private queryPrintDetails(): void {
    this.printGetHistoryDetailRequest.waybillNo = "";
    if (this.printDetailForm.packageName) {
      var reg = new RegExp("\n", "g");
      this.printGetHistoryDetailRequest.waybillNo =
        this.printDetailForm.packageName.replace(reg, ",");
    }
    if (!this.printDetailForm.dateRange) {
      this.$message.error("请选择打印日期");
      return;
    }
    if (this.printDetailForm.dateRange.length === 0) {
      this.$message.error("请选择打印日期");
      return;
    }
    this.printGetHistoryDetailRequest.downloadTime =
      this.printDetailForm.dateRange[0];
    this.printGetHistoryDetailRequest.expireTime =
      this.printDetailForm.dateRange[1].replace("00:00:00", "23:59:59");
    this.printGetHistoryDetailRequest.matOrgCode = this.loginData.orgCode;
    var res = getPrintGetHistoryDetail(
      JSON.stringify(this.printGetHistoryDetailRequest)
    );
    let apiRes: HttpApiResponse<PrintGetHistoryDetailResponse[]> =
      JSON.parse(res);
    if (apiRes.respcode !== "000") {
      this.$message.error(apiRes.respMessage);
      return;
    }
    var compare = function (obj1, obj2) {
      var val1 = obj1.downloadTime;
      var val2 = obj2.downloadTime;
      var time1 = dayjs(val1);
      var time2 = dayjs(val2);
      if (time1 < time2) {
        return 1;
      } else if (time1 > time2) {
        return -1;
      } else {
        return 0;
      }
    };

    apiRes.data.sort(compare);
    apiRes.data = apiRes.data.map((element) => {
      element.matOrgCode = this.loginData.orgName;

      if (element.productType == "YX") {
        element.productType = "异形";
      }
      if (element.productType == "GJ") {
        element.productType = "国际";
      }
      if (element.productType == "WJ") {
        element.productType = "文件";
      }
      if (element.productType == "WZ") {
        element.productType = "业务废品";
      }

      return element;
    });
    this.searchResultShowList = apiRes.data;
    this.tabSelectIndex = "1";
    this.printDetailDialogFormVisible = false;
  }

  private printGetHistoryNumRequest: PrintGetHistoryNumRequest = {
    downloadTime: "",
    expireTime: "",
    extend1: "",
    extend2: "",
    extend3: "",
    matOrgCode: "",
    packageName: "",
    packageType: "",
    printSequence: "",
    productType: "",
    takeApartOrgCode: "",
    takeApartOrgName: "",
    waybillNo: "",
  };

  private tabTableClick(tab): void {
    if (tab.name === "1") {
      this.printDetailDialogFormVisible = true;
      this.calcTableHeight();
    }
  }

  private countNumReadonly = false;

  private calcTableHeight() {
    this.$nextTick(() => {
      const tabs: HTMLElement = document.querySelector(".el-tabs");
      const tabHeader: HTMLElement = document.querySelector(".el-tabs__header");
      const tips: HTMLElement = document.querySelector("._print-tips");

      if (!tabs || !tabHeader || !tips) {
        this.tableHeight = null;
        return;
      }
      this.tableHeight = tabs.offsetHeight - tabHeader.offsetHeight - tips.offsetHeight - 15 * 2 - 5
    });
  }

  //查询打印数量
  private queryHistoryNum() {
    debugger;
    this.countNumReadonly = true;
    this.printedResultShowList = [];
    this.printGetHistoryNumRequest.downloadTime =
      this.printCountForm.dateRange[0];
    this.printGetHistoryNumRequest.expireTime =
      this.printCountForm.dateRange[1].replace("00:00:00", "23:59:59");
    this.printGetHistoryNumRequest.matOrgCode = this.loginData.orgCode;
    var res = getHistoryNum(JSON.stringify(this.printGetHistoryNumRequest));
    var apiRes: HttpApiResponse<PrintGetHistoryDetailResponse[]> =
      JSON.parse(res);
    if (apiRes.respcode === "000") {
      if (apiRes.data && apiRes.data.length) {
        let historyProductType = "";
        for (let i = 0; i < apiRes.data.length; i++) {
          var e = apiRes.data[i];
          let type = "";
          if (e.packageType === "QY") {
            type = "汽运";
          } else if (e.packageType === "HK") {
            type = "航空";
          } else {
            type = e.packageType;
          }

          switch (e.productType) {
            case "普通":
              historyProductType = "普通";
              break;
            case "圆准达":
              historyProductType = "圆准达";
              break;
            case "VIP":
              historyProductType = "VIP";
              break;
            case "YX":
              historyProductType = "异形";
              break;
            case "GJ":
              historyProductType = "国际";
              break;
            case "WJ":
              historyProductType = "文件";
              break;
            case "WZ":
              historyProductType = "业务废品";
              break;
          }
          var item = {
            ID: "",
            Name: e.packageName,
            UnpackOrgName: e.takeApartOrgName,
            Type: type,
            edit: false,
            Count: 0,
            // UnpackOrgCode: "",
            UnpackOrgCode: e.takeApartOrgCode,
            countNum: e.printSequence,
            FirstCode: e.firstCode,
            ProductType: historyProductType

          };
          this.printedResultShowList.push(item);
          var _printedResultShowList = this.printedResultShowList;
          _printedResultShowList.forEach((row) => {
            this.$nextTick(() => {
              (
                this.$refs.multipleTable as Vue & {
                  toggleRowSelection: Function;
                }
              ).toggleRowSelection(row, true);
            });
          });
        }
        this.printCountDialogFormVisible = false;
        this.tabSelectIndex = "0";
      } else {
        this.$message.warning("未查询到数据或历史打印记录已被清除");
      }
    }
  }
  private currentRowIndex = "";

  private tableRowClassName({ row, rowIndex }) {
    row.row_index = rowIndex;
  }
  private onRowClick(row, event, column) {
    this.currentRowIndex = row.row_index;
  }
  private RefreshPrinterFunc() {
    this.GetAllPrinters();

    this.$message.success("打印机重新加载完成");
  }

  private showMessageDialog() {
    this.isShowMessageDialog = true;
    this.stopPullMessageTimer();
  }

  @Watch('isShowMessageDialog')
  private onMessageDialogClose(val) {
    if (!val) {
      this.startPullMessageTimer();
    }
  }

  private pullMessageRemind() {
    const request = {
      devMac: this.globalConfig.LocalMac,
      devType: this.globalConfig.CurrentDeviceType,
      body: {
        mac: this.globalConfig.LocalMac,
      }
    };
    try {
      const response = queryMessageRemind(request);
      if (response.respcode === '000') {
        this.messages = response.data || [];
      } else {
        this.messages = [];
      }
    } catch (e) {
      LogHelper.WriteLog("查询提醒消息失败：" + e.toString());
    }
  }

  private startPullMessageTimer() {
    this.stopPullMessageTimer();
    this.pullMessageRemind();
    this.pullTimerId = setInterval(this.pullMessageRemind, 1000 * 60 * 60);
  }

  private stopPullMessageTimer() {
    if (this.pullTimerId) {
      clearInterval(this.pullTimerId);
      this.pullTimerId = null;
    }
  }

  private updateMessageRemind(id) {
    const request = {
      devMac: this.globalConfig.LocalMac,
      devType: this.globalConfig.CurrentDeviceType,
      body: {
        mac: this.globalConfig.LocalMac,
        id,
      }
    };
    try {
      updateMessageRemind(request);
    } catch (e) {
      LogHelper.WriteLog("更新提醒消息失败：" + e.toString());
    }
  }
}
